//@ts-nocheck
import { useState, useEffect } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@components/Layout';
import {
  GlobalStyle,
  BlogSection,
  ArticleWrap,
  BlogWrapContent,
  MenuWrap
} from '@components/Fblog.styles';
import { LogoWhite } from '@assets/svgs';
import Modal from '@components/Modal';
import { Thecopymodal } from '@components/ModalCopy';
import { CWriting } from '@data/copywriting';
import { BlogItemsBigEvent } from '@components/BlogitemsBigEvent';
import Menu from '@components/Menu/index';
import Footer from '@components/Footer';

import logo from '@assets/logo.png';
import martinswriters_qr from '@assets/martinswriters_qr.png';

const Presentation: NextPage = () => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      setScroll(window.scrollY > 100);
    });
  }, []);

  return (
    <>
      <GlobalStyle />
      <Layout
        showHeader
        showCopyheader
        animationHeader="header"
        showFashionDesktop
        showMenu
        color="#000"
        email="george.martins@jorgedd.com"
        whatAppmsg="Hi George Martins,%0a%0aI would like to talk about my project with you. Could we have a chat about it, please?%0aThank you!%0a%0aMy name:%0aMy number:"
        whatAppLink="I'm looking forward to speak about your project. Click here to connect with me!"
        logo={<LogoWhite />}
      >
        <BlogSection>
          <ArticleWrap>
            <div className={scroll ? 'onScrollBottomMenu' : 'onScrollTopMenu'}>
              <h1>Business.</h1>
              <MenuWrap>
                <Menu
                  showCopywritingMenu
                  subscribeText="Subscribing to our news and latest. Be the first to know about what’s
            happening in the fashion world. The most talented Designers,
            Shows and the most talented Fashion Writers."
                />
              </MenuWrap>
            </div>

            <BlogWrapContent>
              <h2>
                The Future of the Writing Business:<br/> How Martin's is Changing the
                Game?
              </h2>
              <br />
              <br />
              <p style={{ width: '100%' }}>BUSINESS PRESENTATION</p>
              <br />
              <p style={{ width: '100%' }}>
                By{' '}
                <Link
                  href="/profile/george-martins/"
                  style={{ textDecoration: 'underline' }}
                >
                  George Martin's
                </Link>
              </p>
              <p style={{ width: '100%' }}>18 March 2025</p>
              <br />
              <br />
              <Image src={logo} width={1900} height={2525} alt="Ward 4" />
              <br />
              <br />
              <p style={{ width: '100%' }}>
                I’m George Martins, I am a writer and I don’t just write—I
                transform ideas into compelling narratives that drive action. At
                Martin’s, we specialize in Fashion Writing, Copywriting, and
                Tech Writing, helping brands, businesses, and innovators
                communicate with impact. Whether it's crafting high-fashion
                editorials, persuasive sales copy, or simplifying complex tech
                for a wider audience, we bring creativity, precision, and
                strategy to every word. AI can generate text, but it can’t
                capture vision, emotion, or brand identity as we do. Let’s
                create content that speaks, sells, and sets you apart.
              </p>
              <h3>We Are Fashion Writers</h3>
              <p style={{ width: '100%' }}>
                The fashion industry is an exhilarating and constantly changing
                landscape where trends evolve at breakneck speed. Our fashion
                writers have an in-depth understanding of the industry, crafting
                compelling narratives that bring collections to life. From
                runway reviews and designer interviews to trend reports and
                editorial features, Martin's is dedicated to ensuring every
                piece of content reflects sophistication, elegance, and brand
                identity. So, whether you're a luxury fashion house or an
                emerging designer, our words will elevate your brand and
                captivate your audience.
              </p>
              <h3>We Are Copywriters</h3>
              <p style={{ width: '100%' }}>
                Great copy is so much more than just information – it's a tool
                for persuasion, inspiration and driving real action. Here at
                Martin's, we create copy that converts. Our talented team of
                copywriters are masters in crafting captivating marketing
                materials, engaging website content, compelling email campaigns,
                and persuasive micro-website campaigns that directly connect
                with your target audience. We don't just understand the
                psychology of consumer behavior, we use it to create content
                that is persuasive and drives results. So, whether you need a
                brand voice overhaul or a high-converting sales page, Martin's
                is the key to unlocking your brand's potential!
              </p>
              <h3>We Are Tech Writers</h3>
              <p style={{ width: '100%' }}>
                Technology is the backbone of modern business, and our technical
                writers are passionate about making sure that even the most
                innovative solutions are accessible to everyone. Our technical
                writers are the superheroes who make technology accessible to
                everyone, from experts to non-technical users. We specialise in
                software documentation, API guides, user manuals, and SDK
                documentation for Android and iOS platforms. We love
                transforming technical jargon into user-friendly content, and
                we're passionate about helping businesses enhance product
                adoption and customer satisfaction.
              </p>
              <Image
                src={martinswriters_qr}
                width={1900}
                height={2525}
                alt="Ward 4"
                style={{ width: '70%' }}
              />
              <h3>Why Martin’s?</h3>
              <p style={{ width: '100%' }}>
                We believe that writing is more than just words on a page—it’s
                an art, a strategy, and a catalyst for change. What sets us
                apart is our ability to adapt to different industries while
                maintaining a unique and engaging storytelling approach. Our
                team of skilled writers brings a wealth of experience,
                creativity, and strategic thinking to every project.
              </p>
              <h3>Our Commitment:</h3>
              <p style={{ width: '100%' }}>
                <b>Quality:</b> Every piece of content is crafted with precision
                and excellence.
                <br />
                <br />
                <b>Creativity:</b> We bring fresh, original ideas to elevate
                your brand’s messaging.
                <br />
                <br />
                <b>Expertise:</b> Our team consists of industry specialists who
                understand the nuances of fashion, copywriting, and technology.
                <br />
                <br />
                <b>Results:</b> We create content that not only informs but also
                drives engagement and business growth.
                <br />
                <br />
                The future of the writing business is here, and Martin's is at
                the forefront of this amazing revolution. We can create anything
                you need: compelling fashion narratives, persuasive marketing
                copy, crystal-clear technical documentation… we can bring your
                vision to life!
                <br />
                <br />
                <b>Ready to elevate your message? Let’s make it happen.</b>
              </p>
            </BlogWrapContent>
          </ArticleWrap>
          <Footer isClass="footer" />
        </BlogSection>
      </Layout>
    </>
  );
};

export default Presentation;
